/**
 * The margin a shul's sheet keeps from the paper's edge, in inches. The head
 * and foot are stationery and sit nearer the top and bottom than the sides do,
 * which leaves the middle of the page to what the sheet is for. Every sheet
 * that carries the stationery prints at it, so the letterhead lands in one
 * place on all of them.
 */
export const SHEET_MARGIN = { top: 0.35, side: 0.45 } as const
